common.View.create('galaxy::common.form.inputs.Date', {

    dateOptions: {
        showDropdowns: true,
        locale: require('../../daterangepicker').locale,
        autoUpdateInput: false,
    },

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initGui();
    },

    /**
     * Initializes the GUI.
     */
    initGui()
    {
        this.element

            // Single date picker
            .find('.singledate:not([readonly]')
                .daterangepicker({
                    singleDatePicker: true,
                    ...this.dateOptions
                }).on('apply.daterangepicker', (ev, picker) => {
                    // Set date
                    $(ev.currentTarget).val(picker.startDate.format('DD-MM-YYYY'));

                    // Loop day month year
                    let loopItems = {'DD': 'day', 'MM': 'month', 'YYYY': 'year'};
                    for(let [dateFormat, datePart] of Object.entries(loopItems)) {
                        // Is date part only
                        if( this.element.find('input').data(datePart + 'only') ) {
                            $(ev.currentTarget).val(picker.startDate.format(dateFormat));
                        }
                    }
                })
                .end()


            // Date range picker
            .find('.multidate:not([readonly]')
                .daterangepicker(this.dateOptions)
                .on('apply.daterangepicker', function (ev, picker) {
                    $(this).val(picker.startDate.format('DD-MM-YYYY') + ' - ' + picker.endDate.format('DD-MM-YYYY'));
                })
                .end()

            // Remove date value on cancel (or on load)
            .find('.singledate, .multidate')
                .on('cancel.daterangepicker', () => {
                    $(this).val('');
                })
                .end();

    },

});
